<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type_no_border mgr_10" style="padding-top:3px;">
					<label class="mgr_10"><input type="radio" value="S" v-model="invoice_type" v-on:change="search()" /> Sale</label>
					<label class="mgr_10"><input type="radio" value="R" v-model="invoice_type" v-on:change="search()" /> Return</label>
				</span>
				<em class="lt_text">Status</em>
				<span class="int_type_no_border mgr_10">
					<CodeSelect className="tbl_select" :codes="saleStatusCodes" :showDesc="false" v-model="status_code" />
				</span>

				<em v-show="invoice_type == 'R'" class="lt_text">Return Type</em>
				<span v-show="invoice_type == 'R'" class="int_type_no_border mgr_10">
					<CodeSelect className="tbl_select" :codes="returnTypes" :width="70" :showDesc="false" v-model="return_type_code" />
				</span>

				<em class="lt_text">Sales Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="so_date_from"/> ~ <CustomDatePicker v-model="so_date_to"/></span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

				<em class="lt_text">Channel</em>
				<span class="mgr_5">
					<select v-model="channel" class="tbl_select ssm_int">
						<!-- <option v-for="codeType in sortedCodeTypes" v-bind:value="codeType.value" v-bind:key="codeType.value">{{ codeType.text }}</option> -->
						<option :value="null">All</option>
						<option value="WEB">WEB</option>
						<option value="APP">APP</option>
						<option value="RS">RS</option>
						<option v-if="user.company_id == 'he'" value="SHOPIFY">SHOPIFY</option>
					</select>
				</span>
				<!-- <span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span> -->
			</div>
			<div class="left_option">
				<label for="not_price_confirmed" class="mgr_15" v-if="user.company_id == 'newjigu'"> <input type="checkbox" id="not_price_confirmed" v-model="price_not_confirmed" :disabled="invoice_type == 'R'" /> Price Not-Confirmed</label>
				<label for="auto_approved" class="mgr_15"> <input type="checkbox" id="auto_approved" v-model="auto_approved" :disabled="invoice_type == 'R'" /> Pre-Approved Only</label>
				<span class="int_type_no_border mgr_5">
					<!-- <input type="text" class="int_type ssm_int" v-model="ship_to_code" placeholder="Ship To" autocomplete="off" @click="selectPartner('ship')" /> -->
					<PartnerSelect v-model="ship_to_code" ph="Ship To" :customerOnly="true" :showName="false" @set-partner="setPartner" />
				</span>
				<span class="int_type_no_border mgr_5">
					<!-- <input type="text" class="int_type ssm_int" v-model="bill_to_code" placeholder="Bill To" autocomplete="off" @click="selectPartner('bill')" /> -->
					<PartnerSelect v-model="bill_to_code" ph="Bill To" :customerOnly="true" :showName="false" @set-partner="setPartner" />
				</span>

				<em class="lt_text">State</em>
				<span class="int_type_no_border mgr_10"> <CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="states" v-model="state" /> </span>

				<span class="int_type sm_int">
					<input type="text" ref="keyword" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>

				<span v-if="temp_invoices.length > 0"
					><a href="javascript:;" @click="openTempInvoices()"
						><font color="red">{{ temp_invoices.length }} Temp Sales Order(s)</font></a
					></span
				>

				<span v-if="retail_order_count > 0" style="margin-left:10px;">
					<router-link to="/sales/retail/main"
						><font color="blue" class="blink">{{ retail_order_count }} New Order(s) From Retail Store</font></router-link
					>
				</span>
				<div style="float:right;margin-right:7px;">
					<router-link class="gray_bt" :to="{ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.uri, initial_invoice_type: this.invoice_type, initial_ship_to_code: this.ship_to_code } }">Add</router-link>
				</div>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="10px;"><input type="checkbox" @change="selectAll" /></th>
					<th width="145px;">
						<a href="javascript:;" @click="sort('status')">Status{{ sortMark('status') }}</a>
					</th>
					<th v-if="show_void_dt" width="135px;">Void Date</th>
					<th width="105px;">Inv. No</th>
					<!-- <th width="6%">Inv. Date</th> -->
					<th width="140px;">S/O No</th>
					<th width="20px;">Type</th>
					<th width="20px;">Add'l</th>
					<th width="90px;">
						<a href="javascript:;" @click="sort('so_date')">S/O Date{{ sortMark('so_date') }}</a>
					</th>
					<th width="105px;">
						<a href="javascript:;" @click="sort('approval_dt')">Apvl. Date{{ sortMark('approval_dt') }}</a>
					</th>
					<th v-if="user.company_id == 'newjigu'" width="90px;">
						<a href="javascript:;" @click="sort('invoice_date')">Invoice Date{{ sortMark('invoice_date') }}</a>
					</th>
					<th width="80px;">
						<a href="javascript:;" @click="sort('ship_to_code')">Ship To{{ sortMark('ship_to_code') }}</a>
					</th>
					<th width="150px;">
						<a href="javascript:;" @click="sort('ship_to_name')">Ship To Name{{ sortMark('ship_to_name') }}</a>
					</th>
					<th width="80px">
						<a href="javascript:;" @click="sort('bill_to_code')">Bill To{{ sortMark('bill_to_code') }}</a>
					</th>
					<th width="80px;">Bill To Name</th>
					<th :width="user.company_id == 'newjigu' ? '50px;' : '110px;'">
						<a href="javascript:;" @click="sort('sales_group_name')">{{ user.company_id == 'newjigu' ? 'SG' : 'Sales Group' }}{{ sortMark('sales_group_name') }}</a>
					</th>
					<th v-if="isBPorHP" width="110px;">Sales Man</th>
					<th v-if="user.company_id != 'newjigu'" width="70px;">S/O Amt.</th>
					<th v-if="showRequestAmount && invoice_type == 'S'" width="80px;">Req.P Total</th>
					<th v-if="user.company_id == 'newjigu'" width="70px;">Ship(ed) Ttl</th>
					<th width="90px;">
						<a href="javascript:;" @click="sort('crt_name')">S/O Entry{{ sortMark('crt_name') }}</a>
					</th>
					<th v-if="invoice_type == 'R'" width="70px;">
						Total Amt.
					</th>
					<th width="60px;">
						<span v-if="invoice_type == 'S'">Channel</span>
						<span v-if="invoice_type == 'R'">Inv. Amt.</span>
					</th>
					<th>
						<template v-if="user.company_id == 'hairplus'">General Remark</template>
						<template v-else
							><a href="javascript:;" @click="sort('remark')">Accounting{{ sortMark('remark') }}</a></template
						>
					</th>
					<th v-if="user.company_id == 'newjigu'" style="text-align:center;width:45px;">UPD</th>
					<th v-if="user.company_id == 'newjigu'" width="150px;">Cust. PO Number</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no" :class="{ 'visited-row': invoice.invoice_no === visited_invoice_no }">
					<td><input type="checkbox" v-model="invoice.selected" /></td>
					<td
						class="al_center"
						:title="
							user.company_id == 'beautyplus' && invoice.invoice_type == 'S' && (invoice.status_code == 'A' || invoice.status_code == 'O') && !invoice.auto_approved && invoice.pre_approval_reason
								? 'Not Pre-Approved by ' + invoice.pre_approval_reason
								: ''
						"
					>
						<span v-if="invoice.auto_approved && invoice.status_code == 'A'"><font color="blue">Pre</font>-</span>{{ invoice.status_code | saleStatusName }}
						<span v-if="invoice.designated" style="color:gray;">(D)</span>
						<span v-if="user.company_id == 'newjigu' && invoice.invoice_type == 'S' && invoice.status_code == 'O' && invoice.price_confirmed" style="color:blue;">(Confirmed)</span>
					</td>
					<td v-if="show_void_dt" class="al_center">
						<span v-if="invoice.status_dt">{{ invoice.status_dt | moment('MM-DD-YY HH:mm:ss') }}</span>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectInvoice(invoice)"
							><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.invoice_dn }}</font></a
						>
					</td>
					<!-- <td class="al_center">{{ invoice.invoice_date }}</td> -->
					<td class="al_left">
						<a href="javascript:;" @click="selectSo(invoice)"
							><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.so_dn }}</font></a
						>
						<a href="javascript:;" @click="viewItems(invoice)">(Item)</a>
					</td>
					<td class="al_center">{{ invoice.invoice_type }}</td>
					<td class="al_center">
						<template v-if="invoice.main_invoice_no">
							<!-- <span :title="'Master SO : '" + invoice.main_invoice_no>&#10004;</span> -->
							<span :title="'Master SO : ' + invoice.main_so_dn">&#10004;</span>
						</template>
						<template v-else-if="invoice.has_additional_so">
							<span title="Has additional SO(s)">M</span>
						</template>
						<!-- {{ invoice.main_invoice_no || invoice.has_additional_so ? '&#10004;' : null }} -->
					</td>
					<td class="al_center">{{ invoice.so_date }}</td>
					<td class="al_center">
						<span v-if="invoice.approval_dt">{{ invoice.approval_dt | moment('MM-DD HH:mm:ss') }}</span>
					</td>
					<td v-if="user.company_id == 'newjigu'" class="al_center">
						<span v-if="invoice.invoice_date">{{ invoice.invoice_date }}</span>
					</td>

					<td class="al_left">
						<a href="javascript:;" :title="invoice.ship_to_address1" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_code }}</a>
					</td>
					<td class="al_left truncate">
						<a href="javascript:;" :title="invoice.ship_to_address1" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_name }}</a>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_code }}</a>
					</td>
					<td class="al_left truncate" :title="invoice.bill_to_name">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_name }}</a>
					</td>
					<td class="al_left">{{ invoice.sales_group_name }}</td>
					<td v-if="isBPorHP" class="al_left truncate" :title="invoice.salesman_name">{{ invoice.salesman_name }}</td>

					<!-- <td class="al_right" v-if="invoice.status_code == 'I'">{{ invoice.total_shipped_amount | toCurrency }}</td>
					<td class="al_right" v-else>{{ invoice.total_amount | toCurrency }}</td> -->
					<td v-if="user.company_id != 'newjigu'" class="al_right">{{ invoice.total_amount | toCurrency }}</td>
					<template v-if="showRequestAmount && invoice_type == 'S'">
						<td class="al_right">{{ invoice.total_request_amount | toCurrency }}</td>
					</template>
					<td v-if="user.company_id == 'newjigu'" class="al_right">{{ invoice.total_shipped_amount | toCurrency }}</td>
					<td class="al_left truncate">{{ invoice.crt_name }}</td>
					<template v-if="invoice_type == 'S'">
						<td class="al_left">{{ invoice.source }}</td>
					</template>
					<template v-else-if="invoice_type == 'R'">
						<td class="al_right">{{ invoice.total_shipped_amount | toCurrency }}</td>
						<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
					</template>
					<template v-else>
						<td class="al_left"></td>
					</template>
					<td class="al_left">
						<template v-if="user.company_id == 'hairplus'">{{ invoice.general_remark }}</template>
						<template v-else>
							<template v-if="user.company_id == 'newjigu'">
								<input type="text" class="tbl_int full_int" v-model="invoice.remark" @focus="$event.target.select()" />
							</template>
							<template v-else>{{ invoice.remark }}</template>
						</template>
					</td>
					<a v-if="modifiable && user.company_id == 'newjigu' && invoice.invoice_no" href="javascript:;" :class="invoice.remark_org == invoice.remark ? 'gray_bt2 disable_bt' : 'gray_bt2'" @click="updateRemark(invoice)">UPD</a>
					<td v-if="user.company_id == 'newjigu'" class="al_left">{{ invoice.customer_po_no }}</td>
				</tr>
				<tr>
					<td :colspan="(isBPorHP || user.company_id == 'newjigu' ? 14 : 13) + (show_void_dt ? 1 : 0)" class="al_right"><font color="red">Total</font></td>

					<td v-if="user.company_id != 'newjigu'" class="al_right">
						<font color="red">{{ total_amount_sum | toCurrency }}</font>
					</td>
					<td v-if="showRequestAmount && invoice_type == 'S'" class="al_right">
						<font color="red">{{ total_request_amount_sum | toCurrency }}</font>
					</td>
					<td v-if="user.company_id == 'newjigu'" class="al_right">
						<font color="red">{{ total_shipped_amount_sum | toCurrency }}</font>
					</td>
					<td></td>
					<td v-if="invoice_type == 'R'"></td>
					<td class="al_right">
						<span v-if="invoice_type == 'R'"
							><font color="red">{{ invoice_amount_sum | toCurrency }}</font></span
						>
					</td>
					<td></td>
					<td v-if="user.company_id == 'newjigu'"></td>
					<td v-if="user.company_id == 'newjigu'"></td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<a href="javascript: void(0);" class="gray_bt" @click="excel()">Excel</a>
			<a v-if="user.company_id == 'jc'" href="javascript:;" type="button" class="gray_bt mgl_15" @click="excelSBM()">SBM Excel</a>
			<a v-if="user.company_id == 'jc'" href="javascript:;" type="button" class="gray_bt mgl_15" @click="sheetSBM()">SBM Sheet</a>
			<template v-if="user.admin_yn == 'Y'">
				<span class="int_type_no_border mgr_5" style="margin-left:20px;"><CodeSelect className="tbl_select" :codes="salesGroups" :showDesc="true" v-model="change_to_sales_group_code"/></span>
				<a href="javascript:;" class="gray_bt" @click="changeSalesGroup()">Change Sales Group</a>
				<span class="int_type_no_border mgr_5" style="margin-left:20px;"><CodeSelect className="tbl_select" :codes="salesmansForChange" :showDesc="true" v-model="change_to_salesman_id"/></span>
				<a href="javascript:;" class="gray_bt mgr_15" @click="changeSalesman()">Change Salesman</a>
				<a v-if="status_code == 'H'" href="javascript:;" class="gray_bt" @click="makeVoidBatch()">Void Selected</a>
			</template>
			<ul>
				<li class="mgr_15">
					<PageSizeSelect v-model="page_size" @input="search()" />
				</li>
				<li><a href="javascript: void(0);" class="gray_bt" @click="salesOrderPrint">Print</a></li>
				<li v-if="modifiable && (invoice_type == 'S' || (invoice_type == 'R' && user.so_return))">
					<router-link class="gray_bt" :to="{ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.uri, initial_invoice_type: this.invoice_type, initial_ship_to_code: this.ship_to_code } }">Add</router-link>
				</li>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'TempInvoice'" :draggable="false">
			<template slot="title">Temp Sales Orders</template>
			<template slot="body">
				<div style="width:800px; height:500px;" v-on:keyup.esc="close()">
					<table class="list_tbl tbl_pointer">
						<thead>
							<tr>
								<th width="10%">Ship To</th>
								<th>Name</th>
								<th width="10%">Total Amt.</th>
								<th v-if="showRequestAmount" width="10%">Req.P Total</th>
								<th width="12%">Sales Group</th>
								<th width="14%">Creation Time</th>
								<th width="12%">Created By</th>
								<th width="8%">Delete</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(ti, index) in temp_invoices" v-bind:key="ti.temp_invoice_no" @click="OpenTempSo(ti, $event)">
								<td class="al_left">{{ ti.ship_to_code }}</td>
								<td class="al_left truncate" :title="ti.ship_to_name">{{ ti.ship_to_name }}</td>
								<td class="al_right">{{ ti.total_amount | toCurrency }}</td>
								<td v-if="showRequestAmount" class="al_right">{{ ti.total_request_amount | toCurrency }}</td>
								<td class="al_left">{{ ti.sales_group_name }}</td>
								<td class="al_left">{{ ti.crt_dt | moment('MM-DD HH:mm:ss') }}</td>
								<td class="al_left">{{ ti.crt_name }}</td>
								<td class="al_center"><input type="button" value="Del." class="int_line_bt" name="del" @click.prevent="deleteTempSo(ti, index)" /></td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ViewItems'" :draggable="true">
			<template slot="title">SO No : {{ selected_invoice.so_dn }} Item(s)</template>
			<template slot="body">
				<SoItemPopup :invoice="selected_invoice" v-on:close="closeModal()" />
			</template>
		</Modal>
		<SheetCopyPopup v-if="sheet_popup" :sheet="sheet_popup" @close="sheet_popup = null" />
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import {
	apiSoIndex,
	apiSelectInvoiceList,
	apiInvoicePrintDataList,
	apiDeleteTempInvoice,
	apiUpdateSalesOrderListPrint,
	apiUpdateRemarkOnly,
	apiUpdateInvoiceSalesGroupBatch,
	apiUpdateInvoiceSalesmanBatch,
	apiVoidSoBatch,
} from '@/api/sales/invoice.js';
import { companyMrtUrl, getMrtFile, isEmpty, objectToUrlParam, PrintType, Report } from '@/api/util';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import Modal from '@/components/common/Modal';
import SoItemPopup from '@/components/common/SoItemPopup';
import { today, daysAgo } from '@/utils/date.js';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import SheetCopyPopup from '@/components/common/SheetCopyPopup';
import { saveListScroll, takeListScroll } from '@/utils/listScroll.js';

export default {
	beforeRouteLeave(to, from, next) {
		saveListScroll(this.uri, this.visited_invoice_no);
		next();
	},
	data: function() {
		return {
			uri: null,
			visited_invoice_no: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			saveParam: {},

			invoice_type: 'S',
			status_code: null,
			searched_status_code: null,
			so_date_from: daysAgo(3),
			so_date_to: today(),
			sales_group_code: null,
			ship_to_code: null,
			bill_to_code: null,
			state: null,
			keyword: null,
			channel: null,
			return_type_code: null,
			auto_approved: false,

			sort_key: 'so_date',
			sort_direction: 'DESC',

			salesGroups: [],
			states: [],
			saleStatusCodes: [],
			returnTypes: [],

			invoices: [],
			temp_invoices: [],

			modalName: '',
			showModal: false,

			total_amount_sum: 0,
			invoice_amount_sum: 0,
			total_request_amount_sum: 0,
			total_shipped_amount_sum: 0,

			retail_order_count: 0,

			price_not_confirmed: false,

			selected_invoice: {},

			salesmans: [],

			change_to_sales_group_code: null,
			change_to_salesman_id: null,

			sheet_popup: null,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		showRequestAmount() {
			if (this.user.company_id == 'newjigu') return true;
			else return false;
			//return this.user && ['beautyplus', 'hairplus'].includes(this.user.company_id);
		},
		isBPorHP() {
			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') return true;
			else return false;
		},
		show_void_dt() {
			return this.user.company_id == 'beautyplus' && this.searched_status_code == 'VI';
		},
		salesmansForChange() {
			const filteredSalesmans = this.change_to_sales_group_code ? this.salesmans.filter(sm => sm.sales_group_code == this.change_to_sales_group_code) : this.salesmans;

			return filteredSalesmans.map(sm => ({ code: sm.user_id, name: sm.user_name }));
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
		PartnerSelect,
		Modal,
		PageSizeSelect,
		SoItemPopup,
		SheetCopyPopup,
	},
	methods: {
		getSalesGroupName(sales_group_code) {
			return this.salesGroups.filter(sg => sg.code == sales_group_code)[0].name;
		},
		getSalesmanName(salesman_id) {
			return this.salesmans.filter(sm => sm.user_id == salesman_id)[0].user_name;
		},
		async makeVoidBatch() {
			if (this.invoices.filter(i => i.selected).length === 0) {
				this.$toast.error('Nothing Selected.');
				return;
			}

			var msg = 'Are you sure to make void of the selected?';

			if (confirm(msg)) {
				//console.log({ invoices: this.invoices.filter(i => i.selected && i.status_code == 'H') });
				const { data } = await apiVoidSoBatch({ invoices: this.invoices.filter(i => i.selected && i.status_code == 'H').map(i => ({ invoice_no: i.invoice_no })) });

				if (data.result) {
					this.$toast.success('Updated successfully');
					this.invoices
						.filter(i => i.selected && i.status_code == 'H')
						.forEach(invoice => {
							invoice.status_code = 'V';
							invoice.selected = false;
						});
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		async changeSalesGroup() {
			if (this.invoices.filter(i => i.selected).length === 0) {
				this.$toast.error('Nothing Selected.');
				return;
			}

			if (!this.change_to_sales_group_code) {
				this.$toast.error('Sales group not selected.');
				return;
			}

			var msg = 'Are you sure to change sales group of the selected?';

			if (confirm(msg)) {
				const { data } = await apiUpdateInvoiceSalesGroupBatch({ invoices: this.invoices.filter(i => i.selected), sales_group_code: this.change_to_sales_group_code });

				if (data.result) {
					this.$toast.success('Updated successfully');
					var vm = this;
					this.invoices
						.filter(i => i.selected)
						.forEach(invoice => {
							invoice.sales_group_code = vm.change_to_sales_group_code;
							invoice.sales_group_name = vm.getSalesGroupName(vm.change_to_sales_group_code);
						});
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		async changeSalesman() {
			if (this.invoices.filter(i => i.selected).length === 0) {
				this.$toast.error('Nothing Selected.');
				return;
			}

			if (!this.change_to_salesman_id) {
				this.$toast.error('Salesman not selected.');
				return;
			}

			if (confirm('Are you sure to change salesman of the selected?')) {
				const { data } = await apiUpdateInvoiceSalesmanBatch({ invoices: this.invoices.filter(i => i.selected), salesman_id: this.change_to_salesman_id });

				if (data.result) {
					this.$toast.success('Updated successfully');
					var vm = this;
					this.invoices
						.filter(i => i.selected)
						.forEach(invoice => {
							invoice.salesman_id = vm.change_to_salesman_id;
							invoice.salesman_name = vm.getSalesmanName(vm.change_to_salesman_id);
						});
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		async updateRemark(invoice) {
			if (invoice.remark_org == invoice.remark) return;

			const { data } = await apiUpdateRemarkOnly(invoice);

			if (data.result) {
				this.$toast.success('Updated successfully');
				invoice.remark_org = invoice.remark;
				this.$forceUpdate();
			} else {
				this.$toast.error('Failed');
			}
		},
		// #3312 SBM Excel 과 SBM Sheet 가 같은 열 정의를 쓴다(출력 동일).
		sbmHeader() {
			return [
				{ key: 'so_dn', name: 'Trans #', width: 15, dataType: defaultDataType.string },
				{ key: 'so_date', name: 'Date', width: 14, dataType: defaultDataType.string },
				{ key: 'status_name', name: 'Order Status', width: 18, dataType: defaultDataType.string },
				{ key: 'customer_po_no', name: 'P/O #', width: 16, dataType: defaultDataType.string },
				{ key: 'remark', name: 'Memo', width: 45, dataType: defaultDataType.string },
				{ key: 'ship_to_name', name: 'Customer Name', width: 30, dataType: defaultDataType.string },
				{ key: 'total_amount', name: 'Order Total', width: 12, dataType: defaultDataType.currency },
				{ key: 'sales_group_name', name: 'Sales Rep', width: 20, dataType: defaultDataType.string },
				{ key: 'ship_to_address1', name: 'Ship To', width: 50, dataType: defaultDataType.string },
				{ key: 'delivery_type_name', name: 'Ship Via', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_owner_name', name: 'Contact 1', width: 20, dataType: defaultDataType.string },
			];
		},
		// #3312 SBM Excel·SBM Sheet 공용 행: 마지막 검색 조건(search 가 paging_yn 'N' 을 넣어 둔 saveParam)으로 조회하고 화면과 같은 상태명을 채운다.
		async sbmRows() {
			const { data } = await apiSelectInvoiceList(this.saveParam);
			var invoiceList = data.invoiceList || [];

			var vm = this;

			invoiceList.forEach(i => {
				i.status_name = vm.$options.filters.saleStatusName(i.status_code);
			});
			return invoiceList;
		},
		async excelSBM() {
			exportDataExcel(await this.sbmRows(), this.sbmHeader(), 'SalesOrderSBM');
		},
		// #3312 SBM 양식 Sheet: SBM Excel 열 앞에 빈 열 1개를 두고 헤더 포함 전체를 클립보드 복사 팝업으로 연다. 검색 전에는 조회하지 않는다.
		async sheetSBM() {
			if (isEmpty(this.saveParam)) {
				this.$toast.error('Please search first');
				return false;
			}
			const invoiceList = await this.sbmRows();
			if (invoiceList.length > 50000) {
				this.$toast.error("Rows Over 50000 Can't Convert into Excel.");
				return false;
			}
			this.sheet_popup = { title: 'Sales Order (SBM Sheet)', headers: this.sbmHeader(), rows: invoiceList, options: { leading_blank: true } };
		},
		async excel() {
			if (!this.list_count) {
				this.$toast.error('No Data to Export.');
				return false;
			}

			const filename = this.invoice_type === 'R' ? 'RETURN_SO_LIST' : 'SO_LIST';
			const { data } = await apiSelectInvoiceList(this.saveParam);

			var invoiceList = data.invoiceList || [];
			//var invoicesSum = data.invoicesSum || {};

			if (invoiceList.length > 50000) {
				this.$toast.error("Rows Over 50000 Can't Convert into Excel.");
				return;
			}

			var vm = this;

			invoiceList.forEach(i => {
				i.status_name = vm.$options.filters.saleStatusName(i.status_code);
				if (i.approval_dt) i.approval_date = vm.$moment(i.approval_dt).format('MM-DD HH:mm:ss');
				else i.approval_date = '';
				if (i.status_dt) i.void_date = vm.$moment(i.status_dt).format('MM-DD-YY HH:mm:ss');
				else i.void_date = '';
			});

			const headers = [
				{ key: 'status_name', name: 'Status', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Inv. No', width: 15, dataType: defaultDataType.string },
				{ key: 'so_dn', name: 'S/O No', width: 15, dataType: defaultDataType.string },
				{ key: 'so_date', name: 'S/O date', width: 10, dataType: defaultDataType.string },
				{ key: 'approval_date', name: 'Approval date', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_code', name: 'Ship To', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_name', name: 'Name', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_code', name: 'Bill To', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_name', name: 'Name', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group', width: 15, dataType: defaultDataType.string },
				{ key: 'payment_term_name', name: 'Payment Term', width: 15, dataType: defaultDataType.string },
				{ key: 'total_amount', name: 'Total Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'total_valid_amount', name: 'Available Amount', width: 15, dataType: defaultDataType.number },
			];

			if (this.show_void_dt) headers.splice(1, 0, { key: 'void_date', name: 'Void Date', width: 18, dataType: defaultDataType.string });

			/* const sum_obj = {
				ship_to_code: 'TOTAL',
				total_shipped_quantity: invoicesSum.total_shipped_quantity_sum,
				total_weight: invoicesSum.total_weight,
				total_shipped_amount: invoicesSum.total_shipped_amount_sum,
				invoice_amount: invoicesSum.invoice_amount_sum,
				box_count: invoicesSum.box_count,
			};

			invoiceList.unshift(sum_obj);
			*/

			exportDataExcel(invoiceList, headers, filename);
		},
		OpenTempSo(ti, event) {
			if (event.target.name == 'del') return;
			//this.$router.push({ name: 'soDetail', params: { mode: 'add', temp_invoice_no: ti.temp_invoice_no }, query: { backUri: this.uri } });
			this.OpenTempSoConfirm(ti);
		},
		OpenTempSoConfirm(ti) {
			this.$router.push({ name: 'soDetail', params: { mode: 'add', temp_invoice_no: ti.temp_invoice_no }, query: { backUri: this.uri } });
		},
		deleteTempSo(ti, index) {
			this.$alertify.confirm('Are you sure to delete?', () => {
				this.tempDeleteConfirm(ti, index);
			});
		},
		async tempDeleteConfirm(ti, index) {
			const { data } = await apiDeleteTempInvoice(ti);

			if (data.result) {
				this.$toast.success('Deleted successfully');
				this.temp_invoices.splice(index, 1);
				if (this.temp_invoices.length == 0) this.closeModal();
			} else {
				this.$toast.error('Failed');
			}
		},
		openTempInvoices() {
			if (this.temp_invoices.length == 1) {
				this.OpenTempSoConfirm(this.temp_invoices[0]);
			} else {
				this.modalName = 'TempInvoice';
				this.showModal = true;
			}
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectInvoices();
			//console.log(sort_key);
		},
		selectAll() {
			this.invoices.forEach(el => (el.selected = event.target.checked));
		},
		async salesOrderPrint() {
			if (this.invoices.filter(i => i.selected).length === 0) {
				this.$toast.error('Nothing Selected.');
				return;
			}

			let invoiceNos = [];
			this.invoices.filter(i => i.selected).forEach(value => invoiceNos.push(value.invoice_no));

			let file = 'SalesOrder';
			if (this.invoice_type === 'R') file = 'ReturnSales';

			let { data } = await apiInvoicePrintDataList(objectToUrlParam({ invoiceNos: invoiceNos }));
			if (data.result_code === 'success') {
				const original_so_list = [];
				let list = [];
				data.invoice.forEach(function(invoice) {
					list.push({ invoice: invoice });
					if (!invoice.so_print_dt) original_so_list.push(invoice.invoice_no);
				});

				if (original_so_list.length > 0) {
					// S/O Print 정보 Update
					const { status } = await apiUpdateSalesOrderListPrint(original_so_list);
					if (status !== 200) {
						this.$toast.error('Network Error');
						return;
					}
				}

				const reportTemplate = await getMrtFile(companyMrtUrl(file));
				const report = new Report(reportTemplate, list, file, PrintType.List);

				this.$store.commit('setReport', report);

				return true;
			} else {
				this.$toast.error(data.errorSoList + ' An error has occurred.');
				return false;
			}
		},
		selectInvoice(invoice) {
			this.visited_invoice_no = invoice.invoice_no;
			this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},
		selectSo(invoice) {
			// if (invoice.invoice_type == 'R') {
			// 	this.$toast.warning('Return SO will be developed later.');
			// 	return;
			// }
			//console.log(invoice);
			this.visited_invoice_no = invoice.invoice_no;
			this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},
		viewItems(invoice) {
			this.selected_invoice = invoice;
			this.modalName = 'ViewItems';
			this.showModal = true;
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectInvoices(pageNo);
		},
		// setSalesGroup(code) {
		// 	if (code) this.sales_group_code = code.code;
		// 	else this.sales_group_code = null;
		// },
		setPartner() {
			this.search();
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			//this.invoice_type = 'S';
			this.status_code = null;
			this.so_date_from = daysAgo(3);
			this.so_date_to = today();
			this.sales_group_code = null;
			this.ship_to_code = null;
			this.bill_to_code = null;
			this.state = null;
			this.keyword = null;
			this.auto_approved = false;
			this.price_not_confirmed = false;

			//this.search();

			//this.selectInvoices();
			// this.dept_code = null;
		},
		async search() {
			await this.selectInvoices();
			if (this.invoices.length == 1 && this.keyword) this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: this.invoices[0].invoice_no } });
		},
		async selectInvoices(pageNo) {
			// 목록을 다시 조회하면(검색·정렬·페이지 이동) 이전에 누른 행 표시를 지운다. 상세에서 돌아온 경우는 init()이 조회 뒤 다시 표시한다.
			this.visited_invoice_no = null;
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				invoice_type: this.invoice_type,
				status_code: this.status_code,
				so_date_from: this.so_date_from,
				so_date_to: this.so_date_to,
				sales_group_code: this.sales_group_code,
				ship_to_code: this.ship_to_code,
				bill_to_code: this.bill_to_code,
				state: this.state,
				keyword: this.keyword,
				channel: this.channel,
				normal_temp_type: 'all',
				from_so_main: true,
				include_total_request_amount: this.showRequestAmount,

				include_retail_count: true,
				retail_order_status: 'O',
				retail_order_date_from: daysAgo(6),
				retail_order_date_to: today(),
			};
			if (this.invoice_type == 'S' && this.auto_approved) param.auto_approved = this.auto_approved;
			if (this.invoice_type == 'S' && this.price_not_confirmed) param.price_not_confirmed = this.price_not_confirmed;

			//const { data } = await selectAllPensioner();
			if (this.invoice_type == 'R') param.return_type_code = this.return_type_code;
			const { data } = await apiSelectInvoiceList(param);

			this.saveParam = param;
			this.saveParam.paging_yn = 'N';
			this.searched_status_code = param.status_code;
			// this.pensioners = data;
			// if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// 	this.selectRow(this.pensioners[0]);
			// }
			//console.log(data);
			if (Array.isArray(data.invoiceList)) data.invoiceList.forEach(el => (el.selected = false));
			this.invoices = data.invoiceList;
			this.invoices.forEach(i => {
				i.remark_org = i.remark;
			});
			this.list_count = data.invoicesSum.list_count; //data.list_count;
			this.total_amount_sum = data.invoicesSum.total_amount_sum;
			this.invoice_amount_sum = data.invoicesSum.invoice_amount_sum;
			this.total_request_amount_sum = data.invoicesSum.total_request_amount_sum;
			this.total_shipped_amount_sum = data.invoicesSum.total_shipped_amount_sum;

			this.temp_invoices = data.tempInvoiceList;
			this.retail_order_count = data.retailOrderCount;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/sales/so_main?page_no=' + this.page_no;
			if (this.invoice_type) uri += '&invoice_type=' + this.invoice_type;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.status_code) uri += '&status_code=' + this.status_code;
			if (this.return_type_code) uri += '&return_type_code=' + this.return_type_code;
			if (this.so_date_from) uri += '&so_date_from=' + this.so_date_from;
			if (this.so_date_to) uri += '&so_date_to=' + this.so_date_to;
			if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			if (this.ship_to_code) uri += '&ship_to_code=' + this.ship_to_code;
			if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			if (this.state) uri += '&state=' + this.state;
			if (this.channel) uri += '&channel=' + this.channel;
			if (this.auto_approved) uri += '&auto_approved=' + this.auto_approved;
			if (this.price_not_confirmed) uri += '&price_not_confirmed=' + this.price_not_confirmed;
			if (this.page_size) uri += '&page_size=' + this.page_size;
			if (this.sort_key) uri += '&sort_key=' + this.sort_key;
			if (this.sort_direction) uri += '&sort_direction=' + this.sort_direction;

			////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		gotoPartner(code) {
			//console.log(code);
			//this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
			window.open(routeData.href, 'herp_partner');
		},
		async index() {
			const { data } = await apiSoIndex();

			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
			this.returnTypes = data.returnTypeList;
			this.states = data.stateList;
		},
		async init() {
			await this.index();
			this.saleStatusCodes = this.$saleStatusCodes;

			// this.so_date_from = today();
			// this.so_date_to = today();

			// if (this.$route.query.sort_key) this.sort_key = this.$route.query.sort_key;
			// if (this.$route.query.sort_direction) this.sort_direction = this.$route.query.sort_direction;
			// if (this.$route.query.active_yn) this.active_yn = this.$route.query.active_yn;

			// if (this.$route.query.partner_type) this.partner_type = this.$route.query.partner_type;
			// if (this.$route.query.grade) this.grade = this.$route.query.grade;
			// if (this.$route.query.state) this.state = this.$route.query.state;
			// if (this.$route.query.country) this.country = this.$route.query.country;
			if (this.$route.query.invoice_type) this.invoice_type = this.$route.query.invoice_type;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.status_code) this.status_code = this.$route.query.status_code;
			if (this.$route.query.return_type_code) this.return_type_code = this.$route.query.return_type_code;
			if (this.$route.query.so_date_from) {
				if (this.$route.query.so_date_from === 'NON_SELECT') this.so_date_from = null;
				else this.so_date_from = this.$route.query.so_date_from;
			}
			//if (this.$route.query.so_date_from) this.so_date_from = this.$route.query.so_date_from;
			if (this.$route.query.so_date_to) {
				if (this.$route.query.so_date_to === 'NON_SELECT') this.so_date_to = null;
				else this.so_date_to = this.$route.query.so_date_to;
			}
			//if (this.$route.query.so_date_to) this.so_date_to = this.$route.query.so_date_to;
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			if (this.$route.query.ship_to_code) this.ship_to_code = this.$route.query.ship_to_code;
			if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
			if (this.$route.query.state) this.state = this.$route.query.state;
			if (this.$route.query.channel) this.channel = this.$route.query.channel;
			if (this.$route.query.auto_approved) this.auto_approved = this.$route.query.auto_approved;
			if (this.$route.query.price_not_confirmed) this.price_not_confirmed = this.$route.query.price_not_confirmed;

			if (this.$route.query.initial_invoice_type) this.invoice_type = this.$route.query.initial_invoice_type;

			if (this.$route.query.page_size) this.page_size = Number(this.$route.query.page_size);
			if (this.$route.query.sort_key) this.sort_key = this.$route.query.sort_key;
			if (this.$route.query.sort_direction) this.sort_direction = this.$route.query.sort_direction;

			await this.selectInvoices(this.$route.query.page_no);

			// 목록 URL로 돌아온 경우(뒤로가기, 상세의 Cancel·저장 후 복귀) 떠나기 전 스크롤 위치로 되돌리고 마지막으로 누른 행을 표시한다.
			if (this.$route.query.page_no) {
				const position = takeListScroll(this.uri);
				if (position) {
					this.visited_invoice_no = position.row_key;
					this.$nextTick(() => window.scrollTo(position.x, position.y));
				}
			}
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_so_main');
		this.$store.commit('setSubTitle', 'Sales -> Sales Order');

		//this.selectInvoices();
		this.init();

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();
		this.$refs.keyword.focus();
		//makeTableResizable();
	},
};
</script>

<style scoped>
/* 상세에 다녀온 뒤 목록으로 돌아왔을 때 마지막으로 누른 행 (v2 방문 행 표시와 같은 색) */
.list_tbl tbody tr.visited-row td {
	background: #fff9e6;
}

@keyframes blink-effect {
	50% {
		opacity: 0;
	}
}

.blink {
	animation: blink-effect 1s step-end infinite;

	/*
  animation-name: blink-effect;
  animation-duration: 1s;
  animation-iteration-count:infinite;
  animation-timing-function:step-end;
  */
}
</style>
